import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=e509130e&scoped=true"
import script from "./EditClient.vue?vue&type=script&lang=js"
export * from "./EditClient.vue?vue&type=script&lang=js"
import style0 from "./EditClient.vue?vue&type=style&index=0&id=e509130e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e509130e",
  null
  
)

export default component.exports